<template>
	<div class="config">
		<DateRange v-if="filter.param == 'date'" v-bind:filter="filter">
		</DateRange>
		<span v-else-if="filter.param == 'last'">
			Find patients over the last <strong>{{ filter.last }}</strong> days
		</span>
		<span v-else>
			Find patients over all time
		</span>
		<el-button style="display:block;width:100%;" type="text" @click="showRule = !showRule">
			<small><strong style="color:#7f7f7f">{{ showRule ? 'Hide' : 'Show' }} conditions</strong></small>
		</el-button>
		<div class="predicates" v-if="showRule">
			<el-table
		      :data="filter.predicate.term"
			  :show-header="false"
		      style="width: 100%">
			  <el-table-column
			  	width="40">
				<template slot-scope="scope">
					<img :src="getPredicateImage(scope.row.predicate)">
				</template>
			  </el-table-column>
		      <el-table-column
		        width="300">
				<template slot-scope="scope">
					<div class="name">
						<strong>{{ getPredicateName(scope.row.predicate) }}</strong>
					</div>
				</template>
		      </el-table-column>
		      <el-table-column
		        prop="name"
		        label="Name">
				<template slot-scope="scope">
					<div class="args">
						<span class="arg" v-for="arg in scope.row.predicate.arg">
							{{ getPredicateArg(scope.row.predicate, arg) }}
						</span>
					</div>
				</template>
		      </el-table-column>
		    </el-table>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import predicates from '../predicate'
import ParamComponents from './param/components'

export default {
	name: 'filter-viewer',

	props: {
		filter: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			arg: {},
			showRule: false
		}
	},

	watch: {
		arg() {
			Vue.set(this.filter, 'arg', this.arg)
		}
	},

	created() {
		Promise.all(this.filter.predicate.term.map((term) => {
			if (Array.isArray(term.predicate.arg)) {
				return this.loadContent({
					type: term.predicate.id[0],
					id: term.predicate.arg
				})
			}
			return Promise.resolve()
		}))
	},

	methods: {
		...mapActions('content', ['loadContent']),
		edit() {
			this.$emit('edit')
		},
		getPredicateImage(predicate) {
			return require('../../patient/card/image/' + predicate.id[0] + '.png')
		},
		getPredicateName(predicate) {
			let group = predicates.find((p) => (p.option.value === predicate.id[0]))
			if (group && group.option && group.option.children && predicate.id.length > 1) {
				let data = group.option.children.find((child) => (child.value === predicate.id[1]))
				if (data) {
					return group.option.label + ' - ' + data.label
				}
			}
			return null
		},
		getPredicateArg(predicate, arg) {
			// TODO: handle special predicate cases
			let content = this.getContent(predicate.id[0], arg)
			if (content)
				return content.title || content.name
		}
	},

	computed: {
		...mapGetters('content', [
			'getContent'
		])
	},

	components: {
		...ParamComponents
	}
}
</script>

<style lang="scss" scoped>
.config {
	padding: 5px 10px;
	line-height: 30px;

	> span {
		color: #355170;
		font-weight: 700;
	}
}
.predicates {
	img {
		float: left;
		width: auto;
		height: 24px;
	}
	.name {
		font-size: 16px;
	}
	.args {
		line-height: 28px;

		.arg {
			font-size: 16px;
			padding: 2px 6px;
			background: #f0f0f0;
			border-radius: 10px;
			margin-right: 5px;
		}
	}
}
.action {
	padding: 10px;

}
</style>
